import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import "moment-timezone";
import { setLoading as setTboHotelLoading, setSyncTboCities, setError } from "../../features/common/syncTboHotelSlice";
import { syncTBoHotelByCityId, tboSyncedCityList, updateTboHotelPrimaryImage } from "../../services/userservice";
import "./HotelTable.css";

const SyncTboHotels = () => {
    const [currentPage, setCurrentPage] = useState(1);
        const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const { tboSyncCites, loading, error } = useSelector((state) => state?.syncTboHotel ?? { tboSyncCites: [], loading: false, error: null });
    const [showModal, setShowModal] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const dispatch = useDispatch();
    const [primaryImages, setPrimaryImages] = useState({});

    const handlePrimaryImageChange = async (hotelId, imageUrl) => {
        setPrimaryImages((prev) => ({ ...prev, [hotelId]: imageUrl }));
        try {
            const formDataToSend = {
                id: hotelId,
                url: imageUrl
            };
            await updateTboHotelPrimaryImage(formDataToSend);
        } catch (error) {
            console.error("Failed to update primary image:", error);
        }
    };

    useEffect(() => {
        const fetchTboHotelData = async () => {
            try {
                dispatch(setTboHotelLoading(true));
                const response = await tboSyncedCityList();
                dispatch(setSyncTboCities(response?.data.data || []));
            } catch (error) {
                dispatch(setError(error.message));
            } finally {
                dispatch(setTboHotelLoading(false));
            }
        };
        fetchTboHotelData();
    }, [dispatch]);
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value)
        setCurrentPage(1)
    };
    const filteredHotels = tboSyncCites.filter(
        (tboSyncCity) =>
            tboSyncCity?.city_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );


    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    const handleSyncTboHotel = async (id) => {
        try {
            const response = await syncTBoHotelByCityId(id);
            if (response.status === 200 || response.status === 201) {
                alert(response?.data?.message || "The request for syncing tbo hotel for the given city is accepted");
            } else {
                setError(response.message || "Failed to delete user");
            }
        } catch (error) {
            alert("You are not authorized to sync the data");
        }
    };

    const openModal = (userId) => {
        setSelectedUserId(userId);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const confirmDelete = async () => {
        await handleSyncTboHotel(selectedUserId);
        closeModal();
    };

        // Table rows to show per page Start

        const indexOfLastPackage = currentPage * rowsPerPage;
        const indexOfFirstPackage = indexOfLastPackage - rowsPerPage;
        const currentData = filteredHotels.slice(indexOfFirstPackage, indexOfLastPackage);
    
        // bottom pagination start
    
        const totalPages = Math.ceil(filteredHotels.length / rowsPerPage);
    
        const renderPageNumbers = () => {
            const pages = [];
            const maxPagesToShow = 3;
    
            if (totalPages <= 10) {
                for (let i = 1; i <= totalPages; i++) {
                    pages.push(i);
                }
            } else {
                // Always show first 3 pages
                pages.push(1, 2, 3);
    
                // Show "..." if currentPage is beyond 5
                if (currentPage > 5) {
                    pages.push("...");
                }
    
                // Show current page and neighbors
                const start = Math.max(4, currentPage - 1);
                const end = Math.min(totalPages - 3, currentPage + 1);
    
                for (let i = start; i <= end; i++) {
                    if (!pages.includes(i)) pages.push(i);
                }
    
                // Show "..." if currentPage is far from end
                if (currentPage < totalPages - 4) {
                    pages.push("...");
                }
    
                // Always show last 3 pages
                pages.push(totalPages - 2, totalPages - 1, totalPages);
            }
    
            return pages.map((page, index) => (
                <li
                    key={index}
                    className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                >
                    {page === "..." ? (
                        <span className="page-link">...</span>
                    ) : (
                        <button className="page-link" onClick={() => setCurrentPage(page)}>
                            {page}
                        </button>
                    )}
                </li>
            ));
        };


    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">TBO City Sync</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Sync Cities</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="d-md-flex align-items-center justify-content-end">
                                        <Link to="/add-city-to-sync" className="btn btn-primary mb-md-0 mb-2 py-1 mr-3">
                                            <i className="fas fa-plus" /> Add City For Syncing
                                        </Link>
                                        <div className="card-tools">
                                            <div
                                                className="input-group input-group-sm"
                                                style={{ width: "250px" }}
                                            >
                                                <input
                                                    type="text"
                                                    name="table_search"
                                                    className="form-control float-right"
                                                    placeholder="Search"
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                />
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">

                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <label className="me-2">Show</label>
                                            <select
                                                value={rowsPerPage}
                                                onChange={(e) => {
                                                    setRowsPerPage(parseInt(e.target.value));
                                                    setCurrentPage(1); // Reset to first page
                                                }}
                                                className="form-control mx-2 form-select d-inline-block w-auto"
                                            >
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                            <span className="ms-2">entries</span>
                                        </div>
                                        <div>
                                            {/* Optional: Add search or pagination controls here */}
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th className="fixed-column-index">ID</th>
                                                    <th className="fixed-column">City Name</th>
                                                    <th className="fixed-column">Synced Hotels Count</th>
                                                    <th className="fixed-column">Last Synced Date</th>
                                                    <th className="fixed-column">Status</th>
                                                    <th className="fixed-column">Action</th>
                                                </tr>
                                            </thead>
                                            {currentData.length > 0 ? (
                                                <tbody>
                                                    {currentData.map((city) => {
                                                        return (
                                                            <tr key={city.id}>
                                                                <td className="fixed-column">{city.id}</td>
                                                                <td className="fixed-column">{city.city_name}</td>
                                                                <td className="fixed-column">{city.total_synced_hotels}</td>
                                                                <td className="fixed-column">{city.last_synced_at}</td>
                                                                <td className="fixed-column">
                                                                    <span
                                                                        className={`badge p-2 w-100 ${city?.status == "4"
                                                                            ? "badge-success"
                                                                            : (city?.status == "2" ? 'badge-info' : (city?.status == "3" ? 'badge-warning' : (city?.status == "5" ? 'badge-danger' : 'badge-primary')))
                                                                            }`}
                                                                    >
                                                                        {city?.status == "4" ? 'Synced' : (city?.status == "2" ? 'Queue' : (city?.status == "3" ? 'Syncing' : (city?.status == "5" ? 'Error' : 'New')))}
                                                                    </span>
                                                                </td>
                                                                <td className="fixed-column-status">
                                                                    <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                                                        <button
                                                                            className="btn btn-primary btn-sm"
                                                                            onClick={() => handleSyncTboHotel(city?.id)}
                                                                        >
                                                                            <i className="fas fa-sync-alt"></i> Sync
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            ) : (
                                                <tbody>
                                                    <tr>
                                                        <td colSpan="4" className="text-center">No data found</td>
                                                    </tr>
                                                </tbody>
                                            )}
                                        </table>
                                    </div>

                                    <div className="d-md-flex justify-content-between align-items-center mt-3">
                                        <div>
                                            Showing {indexOfFirstPackage + 1} to {Math.min(indexOfLastPackage, filteredHotels.length)} of {filteredHotels.length} entries
                                        </div>
                                        <nav>
                                            <ul className="pagination mb-0">
                                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                                                        Previous
                                                    </button>
                                                </li>

                                                {renderPageNumbers()}

                                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>

                                </div>
                                {/* {tboSyncCites.length > itemsPerPage && (
                                    <div className="card-footer d-flex justify-content-end">
                                        <nav>
                                            <ul className="pagination">
                                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                    <button
                                                        onClick={() => paginate(currentPage - 1)}
                                                        className="page-link"
                                                        disabled={currentPage === 1}
                                                    >
                                                        Prev
                                                    </button>
                                                </li>
                                                {Array.from({ length: totalPages }, (_, index) => index + 1)
                                                    .slice(Math.max(0, currentPage - 3), Math.min(totalPages, currentPage + 2))
                                                    .map((pageNumber) => (
                                                        <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? "active" : ""}`}>
                                                            <button onClick={() => paginate(pageNumber)} className="page-link">
                                                                {pageNumber}
                                                            </button>
                                                        </li>
                                                    ))}
                                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                    <button
                                                        onClick={() => paginate(currentPage + 1)}
                                                        className="page-link"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                )} */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center p-4">
                        <h5>Are you sure you want to delete this Package?</h5>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={closeModal}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirmDelete}>
                        OK
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
export default SyncTboHotels;
